import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Select, MenuItem, Button, TextField, FormControl, InputLabel, Tooltip, Container, Table, AppBar, Toolbar, Typography, Box, Modal, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditDesignation = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [designationName, setDesignationName] = useState('');
  const [departmentName, setDepartmentName] = useState([]);
  const [departmentId, setDepartmentId] = useState('');
  const [DesignationDetails, setDesignationDetails] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const [data, setData] = useState([]);
  const { desigId } = useParams();
  let navigate = useNavigate();
  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;

        const response = await fetch(`${apiUrl}/Department/DepartmentName`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.getItem('token'),
          },
          body: JSON.stringify({}),
        });

        if (response.ok) {
          const responseData = await response.json();
          setDepartmentName(responseData);


        } else {
          setSnackbarMessage('Unable to add Department');
          setOpenSnackbar(true);
          setSnackbarSeverity("error");
        }
      } catch (error) {
        console.error('API request error:', error);
        setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };
    fetchDepartmentData();
  }, []);



  useEffect(() => {
    const fetchDesignationData = async () => {
      try {
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(`${apiUrl}/Designation/DesignationName`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
          body: JSON.stringify({}),
        });

        if (response.ok) {
          const responseData = await response.json();
          const designation = responseData.find((desig) => desig.desigId === parseInt(desigId));
          if (designation) {
            setDesignationName(designation.designationName);
            setDepartmentId(designation.departmentId)
          } else {
            console.error('Designation not found for the given ID');
            setSnackbarMessage('Designation not found');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
          }
          setLoadingBarProgress(100);
        } else {
          console.error('Failed to fetch designation data');
          setSnackbarMessage('Failed to fetch designation data');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        setSnackbarMessage('An error occurred. Please try again later.');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
      }
    };

    fetchDesignationData();
  }, [desigId]);


  const handleUpdate = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Designation/Id?DesigId=${desigId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          deptId: departmentId,
          designationName: designationName,
        }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'Designation has been updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleEdit = (index) => {
    console.log(`Edit Designation details at index ${index}`);
  };

  const handleDelete = (index) => {
    setDesignationDetails((prevDetails) =>
      prevDetails.filter((_, i) => i !== index)
    );
  };

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Designation
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <FormControl fullWidth sx={{ marginBottom: 3 }}>
          <InputLabel id="departmentName-label">Department Name</InputLabel>
          <Select
            labelId="departmentName-label"
            id="departmentName"
            value={departmentId}
            label="Department Name"
            onChange={(e) => setDepartmentId(e.target.value)}
          >
            {departmentName.map((departmentItem) => (
              <MenuItem key={departmentItem.deptId} value={departmentItem.deptId}>
                {departmentItem.departmentName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Designation Name"
          id="designationName"
          sx={{ marginBottom: 3 }}
          value={designationName}
          onChange={(e) => setDesignationName(e.target.value)}
        />
        <Tooltip title={!departmentId && "Select a Department" || !designationName && "Enter Designation Name"} arrow>
          <span>
            <Button
              variant="contained"
              color="primary"
              disabled={!departmentId || !designationName}
              onClick={handleUpdate}
              sx={{ marginRight: 2 }}
            >
              Update
            </Button>
          </span>
        </Tooltip>
        <Button variant="contained" color="error" onClick={handleCancel}>
          Cancel
        </Button>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'Designation Updated ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Designation has been updated successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditDesignation;
